import styles from './BroadcastLayout.module.scss';

interface Props {
  children: React.ReactNode;
}

export const BroadcastSidebar = ({ children }: Props) => {
  return <aside className={styles.sidebar}>{children}</aside>;
};
